import React, { Component } from 'react';

export class TimelineApp extends Component {
  render() {
    return <div>Timeline app goes here.</div>;
  }
}
